import { scrollLock, escListener } from "../utilities/utils"

// gallery on click logic

function setSliderOnClick(sliderEl) {
  if (!sliderEl) return

  sliderEl.swiper.on("click", function () {
    console.log("slider click")
    if (this.slides[this.clickedIndex].getAttribute("data-id")) {
      if (
        !this.slides[this.clickedIndex].classList.contains("model") &&
        !this.slides[this.clickedIndex].classList.contains("video")
      ) {
        openLightBox(this.slides[this.clickedIndex].getAttribute("data-id"))
      }
    }
  })
}

function setGridOnClick(galleryEl) {
  if (!galleryEl) return

  galleryEl.querySelectorAll("figure:not(.figure--model)").forEach((figure) => {
    figure.addEventListener("click", () => {
      openLightBox(figure.parentNode.getAttribute("data-id"))
    })
  })
}

function setGalleryMediaOnClick() {
  const productGallery = document.querySelector(".zoom-lightbox")

  if (productGallery && !productGallery.swiper.initialized) {
    setGridOnClick(productGallery)
  } else {
    setSliderOnClick(productGallery)
  }
}

window.addEventListener("load", setGalleryMediaOnClick)

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", setGalleryMediaOnClick)
}

let lightboxEl, videos = [];

const closeLightBox = () => {
  scrollLock(false)
  escListener(false)
  if (lightboxEl) {
    lightboxEl.classList.remove("pdp-lightbox--open")
  }

  if (videos && videos.length) {
    Array.from(videos).forEach(function (video) {
      if (video.tagName.toLowerCase() === "video") {
        video.pause()
      } else {
        var src = video.src
        video.src = src
      }
    })
  }
}

lightboxEl = document.querySelector(".pdp-lightbox")
if (lightboxEl) {
  const closeButton = lightboxEl.querySelector(".pdp-lightbox__close")
  videos = lightboxEl.querySelectorAll("iframe, video")

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      closeLightBox()
    })
  }

  lightboxEl.querySelectorAll(".figure--image").forEach((image) => {
    image.addEventListener("click", closeLightBox)
  })
}

const jumpToTargetFigure = (id) => {
  lightboxEl.scrollTop =
    lightboxEl.querySelector('figure[data-id="' + id + '"').offsetTop +
    parseInt(getComputedStyle(lightboxEl).paddingTop)
}

const openLightBox = (id) => {
  scrollLock(true)
  escListener(true, closeLightBox)
  lightboxEl.classList.add("pdp-lightbox--open")
  jumpToTargetFigure(id)
}

export { openLightBox }

// Sticky Add to Cart

function enableStickyBar() {
  const scrollATC = document.querySelectorAll(".scroll-atc")
  const stickyBars = document.querySelectorAll(".sticky-add-to-cart")
  if (stickyBars.length === 2) {
    stickyBars[1].remove()
  }

  const stickyBar = stickyBars[0]
  if (stickyBar) {
    document.body.prepend(stickyBar)
  }

  const innerContainer = document.querySelector(".sticky-add-to-cart__inner")
  const stickyBorderElement = document.querySelector(
    ".main-product__add-to-cart .button--add-to-cart",
  )

  if (stickyBorderElement && stickyBar) {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          stickyBar.classList.remove("active")
          innerContainer.classList.remove("sticky-priority")
          return
        }
        if (entry.boundingClientRect.top > 0) {
          stickyBar.classList.remove("active", "sticky-subheader")
          innerContainer.classList.remove("sticky-priority")
        } else {
          stickyBar.classList.add("active", "sticky-subheader")
          innerContainer.classList.add("sticky-priority")
        }
      },
      {
        root: null,
        threshold: 1,
      }
    )
    observer.observe(stickyBorderElement)
  }

  if (scrollATC) {
    scrollATC.forEach((button) => {
      button.addEventListener("click", function (e) {
        const elem = document.querySelector(".main-product__add-to-cart")
        const header = document.getElementById("nav-wrapper")
        const variantSelects = document.querySelector(".main-product__variant-selector")
        let headerOffset = 150
        let elementPosition = elem.offsetTop

        if (header) {
          headerOffset = header.clientHeight
        }

        if (variantSelects) {
          elementPosition = variantSelects.getBoundingClientRect().top + window.scrollY - headerOffset
        }

        const offsetPosition = elementPosition - headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        })

        setTimeout(function() {
          variantSelects.classList.add('ux-shake');
          setTimeout(function() {
            variantSelects.classList.remove('ux-shake');
          }, 800);
        }, 800);
      })
    })
  }
}

window.addEventListener("load", enableStickyBar)

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", enableStickyBar)
}
